import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import './LatestPrice.css';

const API = process.env.REACT_APP_API_URL;
const PRECIO_OFICIAL_CAJA = 7.50;

const ZonePriceCard = ({ price, zoneLabel, loading, error }) => {
  const { t } = useTranslation();

  const renderComparacion = () => {
    if (!price) return null;
    const diferencia = parseFloat(price.price_per_box) - PRECIO_OFICIAL_CAJA;
    const absDiff = Math.abs(diferencia).toFixed(2);
    if (diferencia > 0) return <p className="comparacion positiva">🟢 {t('above_official', { value: absDiff })}</p>;
    if (diferencia < 0) return <p className="comparacion negativa">🔴 {t('below_official', { value: absDiff })}</p>;
    return <p className="comparacion neutra">⚪️ {t('equal_official')}</p>;
  };

  if (loading) return <div className="lp-zone-card lp-zone-card--loading"><div className="loading">{t('loading_latest')}</div></div>;
  if (error)   return <div className="lp-zone-card lp-zone-card--error"><div className="error">{error}</div></div>;

  return (
    <div className="lp-zone-card">
      <div className="lp-zone-header">
        <span className="lp-zone-title">🍌 {zoneLabel}</span>
        {price && <span className="price-date">📅 {format(new Date(price.date), 'MMMM d, yyyy')}</span>}
      </div>

      {price ? (
        <>
          <div className="price-body">
            <div className="price-value">
              ${parseFloat(price.price_per_box).toFixed(2)}
              <span className="price-unit">{t('market_box')}</span>
            </div>
            <div className="price-reference">
              🏛️ {t('official_price')}: <strong>${PRECIO_OFICIAL_CAJA.toFixed(2)}</strong>
            </div>
            {renderComparacion()}
          </div>

          <div className="summary-stats summary-stats--compact">
            <div className="stat-card">
              <h3>⚖️ Kg (19.5)</h3>
              <span className="stat-value">${parseFloat(price.price_per_kg_19_5).toFixed(4)}</span>
            </div>
            <div className="stat-card">
              <h3>📏 Kg (18.8)</h3>
              <span className="stat-value">${parseFloat(price.price_per_kg_18_8).toFixed(4)}</span>
            </div>
          </div>

          <div className="price-footer">
            <p className="price-notes">ℹ️ {t('price_notes')}</p>
          </div>
        </>
      ) : (
        <div className="price-body"><p className="error">📊 {t('no_price_data')}</p></div>
      )}
    </div>
  );
};

const LatestPrice = () => {
  const { t } = useTranslation();
  const [priceNorte, setPriceNorte] = useState(null);
  const [priceSur, setPriceSur]     = useState(null);
  const [loadingNorte, setLoadingNorte] = useState(true);
  const [loadingSur, setLoadingSur]     = useState(true);
  const [errorNorte, setErrorNorte] = useState(null);
  const [errorSur, setErrorSur]     = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      const msg = t('auth_required');
      setErrorNorte(msg);
      setErrorSur(msg);
      setLoadingNorte(false);
      setLoadingSur(false);
      return;
    }

    const headers = { Authorization: `Bearer ${token}` };

    axios.get(`${API}/prices/latest/?zone=norte`, { headers })
      .then(r => setPriceNorte(r.data))
      .catch(err => setErrorNorte(err.response?.status === 401 ? t('session_expired') : t('error_fetching_latest')))
      .finally(() => setLoadingNorte(false));

    axios.get(`${API}/prices/latest/?zone=sur`, { headers })
      .then(r => setPriceSur(r.data))
      .catch(err => setErrorSur(err.response?.status === 401 ? t('session_expired') : t('error_fetching_latest')))
      .finally(() => setLoadingSur(false));
  }, [t]);

  return (
    <div className="latest-price-container">
      <h2>🍌 {t('latest_price')}</h2>
      <div className="lp-zones-grid">
        <ZonePriceCard
          price={priceNorte}
          zoneLabel={t('zona_norte')}
          loading={loadingNorte}
          error={errorNorte}
        />
        <ZonePriceCard
          price={priceSur}
          zoneLabel={t('zona_sur')}
          loading={loadingSur}
          error={errorSur}
        />
      </div>
    </div>
  );
};

export default LatestPrice;
